export enum QuestionStatuses {
  factchecked = 3,
  rejected = 1,
  reported = 4,
  review = 2,
  used = 3,
  unused = 3,
}
